import React from 'react';

import LangSwitch from 'components/LangSwitch/LangSwitch';

import MenuFooterItem from './MenuFooterItem';

const FooterLanguageSwitcher = () => {
  return (
    <MenuFooterItem className="language-switcher">
      <LangSwitch onlyFooter />
    </MenuFooterItem>
  );
};

export default FooterLanguageSwitcher;
